import Component from "flarum/Component";
import Link from "flarum/components/Link";
import Button from 'flarum/components/Button';
import DecorationStorePurchaseModal from './DecorationStorePurchaseModal';
import DecorationStorePurchaseOwnedModal from './DecorationStorePurchaseOwnedModal';
import DecorationStoreSoldOutModal from './DecorationStoreSoldOutModal';
import LogInModal from "flarum/components/LogInModal";
import username from "flarum/helpers/username";
import itemActualCost from "../common/util/itemActualCost";

export default class DecorationStoreListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }

  view() {
    const {itemData} = this.attrs;
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';

    const itemID = itemData.id();
    const itemTitle = itemData.item_title();
    const itemPurchaseID = itemData.purchase_id();
    const itemDesc = itemData.item_desc();
    const itemType = itemData.item_type();
    const itemCost = itemData.item_cost();
    const itemDiscount = itemData.item_discount();
    const itemDiscountDays = itemData.item_discount_days();
    const itemDiscountDaysText = itemDiscountDays===0?"":app.translator.trans("ziven-decoration-store.lib.item-discount-days-left",{days:itemDiscountDays});
    const itemLabelRecommend = itemData.item_label_recommend();
    const itemLabelPopular = itemData.item_label_popular();
    const itemCostText = itemCost===0?app.translator.trans("ziven-decoration-store.lib.item-cost-free"):moneyName.replace('[money]', itemCost);
    const itemCount = 1;
    const itemCostDiscounted = itemActualCost(itemData,itemCount,"store");
    const itemCostDiscountedText = itemDiscount===0?"":moneyName.replace('[money]', itemCostDiscounted)+" ";
    const itemSold = itemData.item_sold();
    const itemAmount = itemData.item_amount();
    const itemPurchaseType = itemData.purchase_type();
    const itemPurchaseTypeText = app.translator.trans("ziven-decoration-store.lib.item-purchase-type-"+itemPurchaseType);
    const itemProperty = JSON.parse(itemData.item_property());

    const itemPropertyImage = itemProperty.image;
    const itemLabelList = [
      {text:itemPurchaseID===null?"":app.translator.trans('ziven-decoration-store.lib.item-label-owned'),background:"green",color:"white"}
    ];

    if(itemDiscount!==0) { itemLabelList.push({text:app.translator.trans('ziven-decoration-store.lib.item-discount-ribbon',{discount:itemDiscount}),background:"indianred",color:"white"}); }
    if(itemLabelRecommend===1){ itemLabelList.push({text:app.translator.trans('ziven-decoration-store.lib.item-label-recommend'),background:"lightskyblue",color:"white"}); }
    if(itemLabelPopular===1){ itemLabelList.push({text:app.translator.trans('ziven-decoration-store.lib.item-label-popular'),background:"darkmagenta",color:"white"}); }

    let itemLabelCount = 0;
    const DecorationStoreDiscountStyle = itemLabelList.length<=1?"":"background-color:"+itemLabelList[1].background+";color:"+itemLabelList[1].color+";";

    let itemImageStyle = "";
    if(itemType==="profileBackground"){
      itemImageStyle = "background-image:url("+itemPropertyImage+")";
    }

    let itemCostStyle = "";
    let itemDiscountStyle = "";
    if(itemDiscount>0){
      itemCostStyle = "text-decoration: line-through;text-decoration-style: dashed;text-decoration-color: red;";
      itemDiscountStyle = "DecorationStoreItemCostOriginal";
    }

    return (
      <div className="DecorationStoreContainer" onclick={() => this.showDetails(itemData)}>
        {itemLabelList.length>=2 && (
          <div className="DecorationStoreRibbon">
            <span className="DecorationStoreRibbonContent" style={DecorationStoreDiscountStyle}>
              <span style="margin-left: 15px;">{itemLabelList[1].text}</span>
            </span>
          </div>
        )}

        <div className="DecorationStoreTitle">
            {itemTitle}
        </div>
        <div className="DecorationStoreItemInfo">
          <div className="DecorationStoreMisc">
            <span className="DecorationStoreItemCost"><span className="DecorationStoreItemCostDiscount">{itemCostDiscountedText}</span><span className={itemDiscountStyle} style={itemCostStyle}>{itemCostText}</span><span className="DecorationStoreItemDiscountDays">{itemDiscountDaysText}</span></span>
          </div>
          <div className="DecorationStoreMisc">
            <span className="DecorationStoreItemSmount"><b>{app.translator.trans('ziven-decoration-store.lib.item-amount')}: </b>{(itemAmount-itemSold)}&nbsp;|&nbsp;</span>
            <span className="DecorationStoreItemPurchaseType"><b>{itemPurchaseTypeText}</b></span>
          </div>
          <div className="DecorationStoreDescription">
            {itemDesc}
          </div>
        </div>
        <div className="DecorationStorePropertyImage">
          {itemType==="avatarFrame" && (
            <img className="DecorationItemAvatarImage" src={itemPropertyImage} />
          )}
          {itemType==="profileBackground" && (
            <div className="DecorationItemProfileBackgroundImage" style={itemImageStyle}></div>
          )}
          {itemType==="usernameColor" && (
            <div style="font-size:30px;height: 100px;" className="decorationItemUsernameColorStyle">
              <div className={itemPropertyImage}>{app.translator.trans("ziven-decoration-store.forum.item-property-style-text-effect")}</div>
            </div>
          )}
        </div>

        <div className="DecorationStoreLabel">
          {itemLabelList.map((labelData) => {
            const labelText = labelData.text;
            const labelBackground = labelData.background;
            const labelColor = labelData.color;

            let labelStyle = "background:"+labelBackground+";color:"+labelColor+";";

            if(itemLabelCount!==0){
              labelStyle+="margin-left: 4px;"
            }

            itemLabelCount++;

            if(labelText!=="" && itemLabelCount!==2){
              return (
                <div style={labelStyle} className="DecorationItemLabel">{labelText}</div>
              );
            }
          })}
        </div>
      </div>
    );
  }

  showDetails(itemData) {
    //
    if(app.session.user){
      const itemPurchaseID = itemData.purchase_id();
      const itemStock = itemData.item_amount()-itemData.item_sold();

      if(itemStock<=0){
          app.modal.show(DecorationStoreSoldOutModal, {itemData});
      }else{  
        if(itemPurchaseID===null){
          app.modal.show(DecorationStorePurchaseModal, {itemData});
        }else{
          app.modal.show(DecorationStorePurchaseOwnedModal, {itemData});
        }
      }
    }else{
      app.modal.show(LogInModal);
    }
  }
}
